import { useState } from 'react'

import { UsersWebPageUser } from '../../../types'

export const useEditUser = () => {
  const [userToEdit, setUserToEdit] = useState<UsersWebPageUser | null>(null)
  const onEdit = (user: UsersWebPageUser) => setUserToEdit(user)
  const closeEditDialog = () => setUserToEdit(null)

  return {
    onEdit,
    userToEdit,
    closeEditDialog
  }
}
